
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'ExportDataPopup'
})
export default class ExportDataPopup extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean
  @Prop({
    type: Array,
    default: () => ['按商品导出', '按订单/客户导出']
  }) tabList!: string[]
  @Prop({ type: Array, default: () => [] }) goodsExportList!: any[]
  @Prop({ type: Array, default: () => [] }) orderExportList!: any[]
  @Prop({ type: Number, default: 0 }) activeTab!: number
  /** jielong：接龙订单；sales：销售单 SalesSilp */
  @Prop({ type: String, default: 'jielong' }) scene!: string

  innerActiveTab = 0

  get isSalesScene (): boolean {
    return this.scene === 'sales'
  }

  get personNumLabel (): string {
    return this.isSalesScene ? '顾客人数' : '接龙人数'
  }

  get arriveDateLabel (): string {
    return this.isSalesScene ? '提货日期' : '到货日期'
  }

  get remarkLabel (): string {
    return this.isSalesScene ? '取件码' : '备注'
  }

  get statusLabel (): string {
    return this.isSalesScene ? '状态' : '订单状态'
  }

  @Watch('activeTab', { immediate: true })
  onActiveTabChange (val: number) {
    this.innerActiveTab = val || 0
  }

  @Watch('value')
  onValueChange (val: boolean) {
    if (val) {
      this.innerActiveTab = this.activeTab || 0
    }
  }

  onVisibleChange (val: boolean) {
    this.$emit('input', val)
  }

  onTabClick (index: number) {
    this.innerActiveTab = index
    this.$emit('change-tab', index)
  }

  onDownload () {
    this.$emit('download', this.innerActiveTab)
  }
}
